export default __webpack_public_path__ + "static/media/comment-filled.c021a175.svg";